import React from "react";

const Loading = ({ message }) => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="flex flex-col items-center">
        {/* Rotating loader */}
        <div className="loader w-16 h-16 border-8 border-t-8 border-blue-500 border-solid rounded-full"></div>

        {/* Loading message */}
        <p className="mt-6 text-white font-semibold text-xl">{message}</p>
      </div>

      {/* Inline keyframe animation for rotating effect */}
      <style jsx>{`
        .loader {
          border-color: #4f97f5 transparent transparent transparent;
          animation: spin 1.5s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default Loading;
